import { render } from "./ArenaForm.vue?vue&type=template&id=11bbf6b2&scoped=true"
import script from "./ArenaForm.vue?vue&type=script&lang=js"
export * from "./ArenaForm.vue?vue&type=script&lang=js"

import "./ArenaForm.vue?vue&type=style&index=0&id=11bbf6b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11bbf6b2"]])

export default __exports__